import Cookies from 'js-cookie'
import { i18n_ag_grid as i18nGridEn } from '@/lang/en'
import { i18n_ag_grid as i18nGridZh } from '@/lang/zh'
import { i18n_ag_grid as i18nGridJa } from '@/lang/ja'
import { i18n_ag_grid as i18nGridRu } from '@/lang/ru'
import { i18n_ag_grid as i18nGridVi } from '@/lang/vi'
import { i18n_ag_grid as i18nGridTh } from '@/lang/th'
import i18n from '@/lang'
/**
 * 设置Ag-grid表格列自定义宽度（根据内容的多少进行适配）
 * @param self 组件对象
 * @param columnIds 设置自动宽度的列ids
 * @param gridOptions
 * @param isAllAuto 是否全部列自定义
 */
const setAutoSizeColumns = function({ self, columnIds, gridOptions, isAllAuto }) {
  let allColumnIds
  if (gridOptions && isAllAuto) {
    allColumnIds = []
    gridOptions.columnApi.getAllColumns().forEach(function(column) {
      console.log('column.colId', column.colId)
      if (column.colId === 'optColumn') {
        allColumnIds.push(column.colId)
      }
    })
  }
  setTimeout(function() {
    (gridOptions || self.gridOptions).columnApi.autoSizeColumns(columnIds || allColumnIds || ['optColumn'])
  })
}

// 列取适配window窗口
const setSizeColumnsToFit = function(params) {
  setTimeout(function() {
    params.api.sizeColumnsToFit()
  })
}

/**
 * 国际化grid的文本（根据语言返回不同的文本）
 * @param key
 * @param defaultValue
 */
export function i18nGridLocalText(key, defaultValue) {
  const lang = Cookies.get('language') || 'zh'
  let text = defaultValue
  if (lang === 'zh') {
    text = i18nGridZh[key]
  } else if (lang === 'ja') {
    text = i18nGridJa[key] || defaultValue
  } else if (lang === 'ru') {
    text = i18nGridRu[key] || defaultValue
  } else if (lang === 'vi') {
    text = i18nGridVi[key] || defaultValue
  } else if (lang === 'th') {
    text = i18nGridTh[key] || defaultValue
  } else {
    text = i18nGridEn[key] || defaultValue
  }
  return text
}

import { Message } from '@/utils/Message'

const getGridSelected = function(gridOptions) {
  const selectedRows = gridOptions.api.getSelectedRows()
  // low
  return selectedRows.length <= 0 ? [] : selectedRows
}

/**
 * 获取指定agGrid 的行数据
 * @param gridOptions
 * @param filedName 字段名称
 * @param tipMessage 错误提示信息
 * @returns {Promise<any>}
 */
const getGridSelectedIds = async function(gridOptions, filedName = 'id', tipMessage) {
  const rows = getGridSelected(gridOptions)
  const ids = rows.map((row, index, arr) => {
    return row[`${filedName}`]
  })
  return await new Promise((resolve, reject) => {
    if (ids.length > 0) {
      resolve(ids)
    } else {
      Message({
        message: tipMessage || i18n.t('Message.PleaseSelectDataFirst'),
        type: 'warning',
        duration: 5 * 1000
      })
      reject(tipMessage || i18n.t('Message.PleaseSelectDataFirst'))
    }
  })
}

// const browseFolder = function(path) {
// try {
//   const Message = '\u8bf7\u9009\u62e9\u6587\u4ef6\u5939' // 选择框提示信息
//   const Shell = new ActiveXObject('Shell.Application')
//   new Workbook()
//   let Folder = Shell.BrowseForFolder(0, Message, 64, 17) // 起始目录为：我的电脑
//   // var Folder = Shell.BrowseForFolder(0, Message, 0); //起始目录为：桌面
//   if (Folder != null) {
//     Folder = Folder.items() // 返回 FolderItems 对象
//     Folder = Folder.item() // 返回 Folderitem 对象
//     Folder = Folder.Path // 返回路径
//     if (Folder.charAt(Folder.length - 1) !== '\\') {
//       Folder = Folder + '\\'
//     }
//     document.getElementById(path).value = Folder
//     return Folder
//   }
// } catch (e) {
//   alert(e.message)
// }
// }

/**
 * 获取带警告提示的headerComponentParams
 * @param {String} tipMessage
 * @returns
 */
const getHeaderComponentParamsWithWarning = function(tipMessage) {
  if (tipMessage) {
    return {
      template: `
      <div class="ag-cell-label-container" role="presentation">
        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
          <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
          <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
          <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
          <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
          <span class="el-icon-warning red" style="width: 12px;margin: 2px 2px 0 -6px;"></span>
          <span ref="eText" class="ag-header-cell-text" role="columnheader" title="${tipMessage}" placement="right-end"></span>
          <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
        </div>
      </div>`
    }
  }
  return {}
}

/**
 * 记录勾选状态
 * @param gridApi 表格api
 * @param keyFiledName 唯一标识字段名称
 */
function recordSelectedStatus(gridApi, keyFiledName) {
  if (gridApi && keyFiledName) {
    const rows = gridApi.getSelectedRows()
    if (rows.length > 0) {
      return {
        // 还原（勾选状态）
        revert() {
          setTimeout(function() {
            const keys = Array.from(rows, p => p[keyFiledName])
            const nodes = gridApi.rowModel.rowsToDisplay
            for (const node of nodes) {
              if (!node.data) {
                continue
              }
              if (keys.includes(node.data[keyFiledName])) {
                node.setSelected(true)
              }
            }
          }, 100)
        }
      }
    }
  }
  return { revert() {} }
}

export { getGridSelectedIds, getGridSelected, setAutoSizeColumns, setSizeColumnsToFit, getHeaderComponentParamsWithWarning, recordSelectedStatus }

